const initialState = {
  selectedTariff: {}
}

const ActivationTariffsModule = {
  namespaced: true,
  state: initialState,
  getters: {
    tariffId: state => {
      return state.selectedTariff?.tariffId
    },
    savedTariff: state => {
      return state.selectedTariff
    }
  },
  actions: {
    selectTariff ({ commit, state, getters, rootGetters }, { tariff, nextStep }) {
      commit('storeTariff', tariff)
      commit('activation/goToStep', nextStep, { root: true })
    }
  },
  mutations: {
    storeTariff (state, selectedTariff) {
      state.selectedTariff = selectedTariff
    }
  }
}

export default ActivationTariffsModule
